import React, { useState, useEffect, Fragment } from 'react';
import {
  Button, Modal, Rate, Radio, Input, Popconfirm,
} from 'antd';
import './style.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import H3Text from '@Uilib/h3Text';
import Crown from '@Images/crown2.png';
import vendorRatingActions from '../../../actions/configurations/vendorRatingActions';

const VendorRating = ({
  getVendorRating, user, getVendorRatingSuccess, selectedEntity, selectedSeller, createVendorRating, createSellerRatingLoading, openModal, callback, SelectPO, grnId, updateVendorRating, updateVendorRatingLoading, isUpdateRating, closeModal, updateCallback,
}) => {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [rating, setRating] = useState(0);
  const [additionalComment, setAdditionalComment] = useState('');
  const [customRatings, setCustomRatings] = useState([]);
  const [lowRatingReason, setLowRatingReason] = useState();
  const [additionalRatingNames, setAdditionalRatingNames] = useState([]);
  const [additionalRatingValue, setAdditionalRatingValue] = useState([]);

  const vendorRating = !user?.tenant_info?.global_config?.sub_modules?.vendor_rating?.is_active;

  useEffect(() => {
    getVendorRating(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    setVisible(openModal);
    if (isUpdateRating) {
      setRating(selectedEntity?.rating_info ? selectedEntity?.rating_info?.overall_rating : 0);
      setLowRatingReason(selectedEntity?.rating_info ? selectedEntity?.rating_info?.low_rating_reason : '');
      setAdditionalComment(selectedEntity?.rating_info ? selectedEntity?.rating_info?.additional_info : '');
    }
  }, [openModal, isUpdateRating]);

  // useEffect(() => {
  //   if (getVendorRatingSuccess) {
  //     const additionalRatingKeys = ['additional_rating_1', 'additional_rating_2', 'additional_rating_3'];

  //     setAdditionalRatingNames(
  //       additionalRatingKeys
  //         .filter((key) => getVendorRatingSuccess[key] === true)
  //         .map((key) => {
  //           const mappingItem = getVendorRatingSuccess.name_mapping.find((item) => item.key === key);
  //           return mappingItem ? mappingItem.name : key;
  //         }),
  //     );
  //   }
  // }, [getVendorRatingSuccess]);

  const handleCancel = () => {
    setVisible(false);
    if (callback) {
      history.push(callback);
    } else {
      window.location.reload();
    }
  };

  const handleRatingChange = (value) => {
    setRating(value);
  };

  const handleSubmit = () => {
    const payload = {
      entity_id: selectedSeller?.seller_info?.seller_id || SelectPO?.seller_info?.seller_id || selectedEntity.seller_id,
      tenant_entity_id: selectedSeller?.tenant_seller_id || SelectPO?.tenant_seller_id || selectedEntity?.tenant_seller_id,
      entity_name: selectedSeller?.seller_info?.seller_name || SelectPO?.seller_info?.seller_name || selectedEntity?.tenant_seller_info?.seller_name,
      source_entity_id: grnId || selectedEntity?.grn_id,
      entity_type: 'SELLER',
      source_entity_name: 'GOOD_RECEIVING_NOTE',
      low_rating_reason: (rating <= 2.5) ? lowRatingReason : '',
      additional_info: additionalComment || '',
      overall_rating: rating,
      type: customRatings || '',
      tenant_id: selectedSeller?.tenant_id || SelectPO?.tenant_id || selectedEntity.grn_tenant_id,
      additional_rating_1: additionalRatingValue[0],
      additional_rating_2: additionalRatingValue[1],
      additional_rating_3: additionalRatingValue[2],
    };
    createVendorRating(payload, () => {
      setVisible(false);
      if (updateCallback) {
        updateCallback();
      } else if (callback) {
        history.push(callback);
      } else {
        window.location.reload();
      }
    });
  };

  const handleUpdateRating = () => {
    const payload = {
      tenant_entity_id: selectedEntity?.tenant_seller_id || selectedEntity?.tenant_seller_info?.tenant_seller_id,
      low_rating_reason: (rating <= 2.5) ? lowRatingReason : '',
      additional_info: additionalComment || '',
      overall_rating: rating,
      tenant_id: selectedEntity.grn_tenant_id,
      entity_rating_id: selectedEntity?.rating_info?.entity_rating_id,
    };
    updateVendorRating(payload, () => {
      setVisible(false);
      if (updateCallback) updateCallback();
    });
  };

  return (
    <div>
      <Modal
        visible={visible}
        onOk={handleSubmit}
        closable={false}
        okText="Submit"
        cancelText="Not Now"
        confirmLoading={createSellerRatingLoading}
        onCancel={isUpdateRating ? closeModal : handleCancel}
        footer={[
          <div
            key={1}
          >

            {vendorRating && (
              <Popconfirm
                placement="topRight"
                title="This feature is not available in your current plan"
                onConfirm={() => window.Intercom('showNewMessage')}
                okText="Contact Us"
                cancelText="Cancel"
              >
                <img className="barcode-restrict" src={Crown} alt="premium" />
              </Popconfirm>
            )}

          </div>,

          <Button
            key="back"
            onClick={isUpdateRating ? closeModal : handleCancel}
          // disabled={vendorRating}
          >
            {isUpdateRating ? 'Cancel' : 'Skip'}
          </Button>,
          isUpdateRating ? (
            <Button
              key="update"
              type="primary"
              loading={updateVendorRatingLoading || createSellerRatingLoading}
              onClick={selectedEntity?.rating_info ? handleUpdateRating : handleSubmit}
              disabled={vendorRating}
            >
              Update
            </Button>
          ) : (
            <Button key="submit" type="primary" loading={createSellerRatingLoading} onClick={handleSubmit} disabled={vendorRating}>
              Submit
            </Button>
          ),
        ]}
      >
        <div className="vendor-rating-container">
          <H3Text text={`How would you rate your experience with ${(selectedSeller?.seller_info?.seller_name || SelectPO?.seller_info?.seller_name || selectedEntity?.tenant_seller_info?.seller_name)?.toProperCase()}?`} className="vendorRating-label" />
          <div className="rating-container">
            <Rate allowHalf onChange={handleRatingChange} value={rating} style={{ fontSize: '28px' }} />
            <div className="rating-info">
              <div className="rating-value">{rating.toFixed(1)}</div>
              <div className="rating-out-of">out of 5</div>
            </div>
          </div>
        </div>

        <div>
          {rating <= 2.5 && rating > 0 && (
            <Fragment>
              <H3Text text="What did you not like about the supplier?" className="addAdditionalComment-label" />
              <Radio.Group
                className="low-rating-options"
                onChange={(event) => setLowRatingReason(event?.target?.value)}
                value={lowRatingReason}
              >
                {getVendorRatingSuccess?.low_rating_reasons?.map((reason, index) => (
                  <Radio
                    key={index}
                    style={{
                      fontSize: '14px',
                      color: '#333',
                      fontWeight: 500,
                    }}
                    value={reason}
                  >
                    {reason.toProperCase()}
                  </Radio>
                ))}
              </Radio.Group>
            </Fragment>
          )}
        </div>

        {/* <div> */}
        {/*  {additionalRatingNames?.map((customReason, index) => ( */}
        {/*    <div key={index} className="custom-rating-item"> */}
        {/*      <H3Text text={customReason?.toProperCase()} className="custom-reason-title" /> */}
        {/*      <div className="custom-rating-controls"> */}
        {/*        <Rate */}
        {/*          value={additionalRatingValue[index]?.rating} */}
        {/*          className="custom-rating-rate" */}
        {/*          allowHalf */}
        {/*          onChange={(value) => { */}
        {/*            const updatedCustomRatings = [...additionalRatingValue]; */}
        {/*            updatedCustomRatings[index] = value; */}
        {/*            setAdditionalRatingValue(updatedCustomRatings); */}
        {/*          }} */}
        {/*        /> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*  ))} */}
        {/* </div> */}

        {/* <div> */}
        {/*  {getVendorRatingSuccess?.custom_reasons?.map((customReason, index) => ( */}
        {/*    <div key={index} className="custom-rating-item"> */}
        {/*      <H3Text text={customReason?.toProperCase()} className="custom-reason-title" /> */}
        {/*      <div className="custom-rating-controls"> */}
        {/*        <Rate */}
        {/*          value={customRatings[index]?.rating} */}
        {/*          className="custom-rating-rate" */}
        {/*          allowHalf */}
        {/*          onChange={(value) => { */}
        {/*            const updatedCustomRatings = [...customRatings]; */}
        {/*            updatedCustomRatings[index] = { */}
        {/*              name: customReason, */}
        {/*              rating: value, */}
        {/*            }; */}
        {/*            setCustomRatings(updatedCustomRatings); */}
        {/*          }} */}
        {/*        /> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*  ))} */}
        {/* </div> */}

        <div style={{ paddingBottom: '10px' }}>
          <H3Text text="Would you like to record more feedback?" className="addAdditionalComment-label" />
          <Input.TextArea
            rows={3}
            value={additionalComment}
            onChange={(e) => setAdditionalComment(e.target.value)}
            className="vendor-rating-textarea"
            placeholder="additional remarks..."
          />
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, VendorRatingReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  getVendorRatingLoading: VendorRatingReducers.getVendorRatingLoading,
  getVendorRatingSuccess: VendorRatingReducers.getVendorRatingSuccess,
  createSellerRatingLoading: VendorRatingReducers.createSellerRatingLoading,
  updateVendorRatingLoading: VendorRatingReducers.updateVendorRatingLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateVendorRating: (payload, callback) => dispatch(vendorRatingActions.updateVendorRating(payload, callback)),
  getVendorRating: (orgId, callback) => dispatch(vendorRatingActions.getVendorRating(orgId, callback)),
  createVendorRating: (payload, callback) => dispatch(vendorRatingActions.createVendorRating(payload, callback)),
});

VendorRating.propTypes = {
  user: PropTypes.any,
  getVendorRatingSuccess: PropTypes.any,
  getVendorRating: PropTypes.any,
  selectedSeller: PropTypes.any,
  selectedEntity: PropTypes.any,
  createVendorRating: PropTypes.any,
  createSellerRatingLoading: PropTypes.any,
  openModal: PropTypes.any,
  SelectPO: PropTypes.any,
  callback: PropTypes.any,
  closeModal: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorRating);
